import React, { Component } from "react";
import { connect } from "react-redux";
import ListItem from "./ListItem";
import JumboListItem from "../JumboMenu/ListItem";
import { Sticky, StickyContainer } from "react-sticky";
import Category from "./Category";
import MList from "@material-ui/core/List";
import Fuse from "fuse.js";
import { isOutOfStock, sortSmartSearchResult } from "./Helpers";
import { isEqual } from "../ProductDetails/ProductFilter/helper";

export class List extends Component {
  sortProducts = (a, b) => {
    switch (this.props.filters.sortBy.value || this.props.sortOption) {
      case "price-low-to-high":
        return a.props.product.price - b.props.product.price;
      case "price-high-to-low":
        return b.props.product.price - a.props.product.price;
      case "name-a-to-z":
        return a.props.product.name.localeCompare(b.props.product.name);
      case "name-z-to-a":
        return b.props.product.name.localeCompare(a.props.product.name);
      case "newest":
        return b.props.product.id - a.props.product.id;
      case "oldest":
        return a.props.product.id - b.props.product.id;
      default:
        return a.props.product.id - b.props.product.id;
    }
  };
  checkIfAnyFilterApplied = () => {
    if (this.props.filters === false) {
      return false;
    }
    const {
      filtersSelected,
      sortBy,
      priceRange,
      selectedCategories,
      nutritionalFact,
    } = this.props.filters;
    return (
      filtersSelected.length > 0 ||
      sortBy.value !== "" ||
      priceRange.range !== null ||
      selectedCategories.length > 0 ||
      this.props.filters.availableProducts === true ||
      !isEqual(nutritionalFact, {
        calories: null,
        carbs: null,
        fats: null,
        protein: null,
        dietaryRestrictions: [],
      })
    );
  };
  getLayout = () => {
    if (
      this.props.settings.store_layout === "jumbo" &&
      !this.checkIfAnyFilterApplied()
    ) {
      return JumboListItem;
    } else if (
      this.checkIfAnyFilterApplied() ||
      this.props.settings.store_layout === "list"
    ) {
      return ListItem;
    } else {
      return ListItem;
    }
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleCoverScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleCoverScroll);
  }
  handleCoverScroll = () => {
    const coverId = `category-cover-${this.props.category.id}`;
    const el = document.getElementById(coverId);
    if (!el) return;

    const top = el.getBoundingClientRect().top;
    const bottom = el.getBoundingClientRect().bottom;

    const isInView = bottom > 0 && top < window.innerHeight;

    if (!isInView) return;

    if (top > 20) {
      el.classList.add("fade-in");
      el.classList.remove("fade-out");
    } else {
      el.classList.add("fade-out");
      el.classList.remove("fade-in");
    }
  };

  render() {
    const { settings, nutritionalFactMaxMin, usedComponents } = this.props;
    const ios =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    let insta = navigator.userAgent.match(/instagram/i);
    const showBanner =
      settings.enable_banner && !this.props.isNotificationDismissed;
    insta = false;
    let offset = 54;
    let PCOffset = 0;
    if (ios && insta) offset += 43;
    if (showBanner) {
      offset += 50;
      PCOffset += 50;
    }
    const options = {
      threshold: 0.39,
      keys:
        settings.enable_smart_search && settings.enable_smart_search_staff
          ? [
              "name",
              "ar_name",
              "description",
              "ar_description",
              "short_description",
              "ar_short_description",
            ]
          : ["name", "ar_name"],
    };

    let products = [];
    let mobileView = this.props.isMobile;
    const checkForFiltersIfApplied = this.checkIfAnyFilterApplied();
    const Item = this.getLayout();
    if (
      (settings.store_layout === "list" || settings.store_layout === "jumbo") &&
      this.props.filter
    ) {
      const fuse = new Fuse(this.props.category.products, options);
      let result = fuse.search(this.props.filter_value || "");
      if (this.props.filter && result.length > 0) {
        result = result
          .map((product) => product.item)
          .filter((product) => product !== undefined);
        if (
          settings.enable_smart_search &&
          settings.enable_smart_search_staff
        ) {
          result.sort((a, b) =>
            sortSmartSearchResult(a, b, this.props.filter_value)
          );
        }
        result.forEach((product) => {
          return products.push(
            <Item
              isFilter={checkForFiltersIfApplied}
              product={product}
              isSearch={this.props.filter}
              filter_value={this.props.filter_value}
              category={this.props.category.slug}
              key={"ListItem_Menu" + product.id}
              category_id={this.props.category.id}
            />
          );
        });
      }
    } else if (this.props.favorite) {
      this.props.category.products.forEach((product) => {
        products.push(
          <Item
            isFilter={checkForFiltersIfApplied}
            product={product}
            isSearch={this.props.filter}
            category={this.props.category.slug}
            key={"ListItem_Menu" + product.id}
            category_id={this.props.category.id}
          />
        );
        return products;
      });
    } else {
      this.props.category.products.forEach((product) => {
        if (
          (!settings.enable_smart_search && checkForFiltersIfApplied) ||
          settings.store_layout === "list" ||
          settings.store_layout === "jumbo"
        ) {
          if (
            !this.props.filter ||
            (this.props.filter &&
              (product.name.toLowerCase().includes(this.props.filter_value) ||
                product.ar_name
                  .toLowerCase()
                  .includes(this.props.filter_value)))
          ) {
            if (
              this.props.filters.filtersSelected.length > 0 &&
              !this.props.filter
            ) {
              if (
                product.filters.some((id) =>
                  this.props.filters.filtersSelected.some(
                    (filter) => filter.value === id
                  )
                ) ||
                this.props.filters.filtersSelected.length ||
                settings.store_layout === "grid" ||
                settings.store_layout === "grid2" ||
                settings.store_layout === "scroll"
              ) {
                products.push(
                  <Item
                    isFilter={checkForFiltersIfApplied}
                    product={product}
                    isSearch={this.props.filter}
                    filter_value={this.props.filter_value}
                    category={this.props.category.slug}
                    key={"ListItem_Menu" + product.id}
                    category_id={this.props.category.id}
                  />
                );
                return products;
              }
            } else {
              products.push(
                <Item
                  isFilter={checkForFiltersIfApplied}
                  product={product}
                  isSearch={this.props.filter}
                  filter_value={this.props.filter_value}
                  category={this.props.category.slug}
                  key={"ListItem_Menu" + product.id}
                  category_id={this.props.category.id}
                />
              );
              return products;
            }
          }
        } else {
          products.push(
            <Item
              isFilter={checkForFiltersIfApplied}
              product={product}
              isSearch={this.props.filter}
              filter_value={this.props.filter_value}
              category={this.props.category.slug}
              key={"ListItem_Menu" + product.id}
              category_id={this.props.category.id}
            />
          );
          return products;
        }
      });
    }
    if (this.props.filter) {
      if (settings.enable_smart_search && settings.enable_smart_search_staff) {
        products.sort((a, b) =>
          sortSmartSearchResult(
            a.props.product,
            b.props.product,
            this.props.filter_value
          )
        );
      }
    } else if (!this.props.favorite) {
      if (this.props.filters.sortBy.value || this.props.sortOption) {
        products = products.sort((a, b) => this.sortProducts(a, b));
      }
      if (this.props.filters.availableProducts) {
        products = products.filter((product) => {
          return (
            !isOutOfStock(
              product.props.product,
              this.props.cart,
              usedComponents
            ) && product.props.product.not_available === false
          );
        });
      }
      if (this.props.filters.priceRange.range !== null) {
        products = products.filter((product) => {
          return (
            product.props.product.price >=
              this.props.filters.priceRange.range[0] &&
            product.props.product.price <=
              this.props.filters.priceRange.range[1]
          );
        });
      }
      if (
        !isEqual(this.props.filters.nutritionalFact, {
          calories: null,
          carbs: null,
          fats: null,
          protein: null,
          dietaryRestrictions: [],
        })
      ) {
        products = products.filter((product) => {
          const isCalories =
            product.props.product?.calories !== null
              ? product.props.product.calories >=
                  this.props.filters.nutritionalFact.calories[0] &&
                product.props.product.calories <=
                  this.props.filters.nutritionalFact.calories[1]
              : false;

          const isCarbs =
            product.props.product?.carbs !== null
              ? product.props.product.carbs >=
                  this.props.filters.nutritionalFact.carbs[0] &&
                product.props.product.carbs <=
                  this.props.filters.nutritionalFact.carbs[1]
              : false;

          const isFats =
            product.props.product?.fats !== null
              ? product.props.product.fats >=
                  this.props.filters.nutritionalFact.fats[0] &&
                product.props.product.fats <=
                  this.props.filters.nutritionalFact.fats[1]
              : false;

          const isProtein =
            product.props.product?.protein !== null
              ? product.props.product.protein >=
                  this.props.filters.nutritionalFact.protein[0] &&
                product.props.product.protein <=
                  this.props.filters.nutritionalFact.protein[1]
              : false;

          const isDietaryRestrictions =
            product.props.product?.dietary_restrictions !== null
              ? this.props.filters.nutritionalFact?.dietaryRestrictions.every(
                  (restriction) => {
                    return product.props.product?.dietary_restrictions.includes(
                      restriction
                    );
                  }
                )
              : false;

          return (
            isCalories &&
            isCarbs &&
            isFats &&
            isProtein &&
            isDietaryRestrictions
          );
        });
      }
    }
    if (products.length) {
      const hasCoverPhoto =
        this.props.category?.cover_photo_large ||
        this.props.category?.cover_photo
          ? true
          : false;

      return (
        <>
          {hasCoverPhoto && (
            <div style={{ padding: 15, paddingBottom: 0 }}>
              <div
                id={`category-cover-${this.props.category.id}`}
                className="category-cover"
              >
                <img
                  src={
                    this.props.category.cover_photo_large ||
                    this.props.category.cover_photo
                  }
                  alt=""
                />
              </div>
            </div>
          )}
          <StickyContainer>
            <Sticky>
              {({ style, isSticky }) => (
                <div
                  style={{ ...style, zIndex: 11 }}
                  className="sticky-category"
                >
                  <Category
                    id={this.props.category.id}
                    onClick={this.props.onClick}
                    language={this.props.language}
                    filter={
                      checkForFiltersIfApplied || this.props.favorite
                        ? true
                        : this.props.filter
                    }
                    min_order={this.props.category.minimum_order_value}
                    settings={this.props.settings}
                    text={
                      this.props.language == "english"
                        ? this.props.category.name
                        : this.props.category.ar_name
                    }
                  />
                </div>
              )}
            </Sticky>
            <MList
              component="nav"
              aria-label="main mailbox folders"
              style={{
                width: "100%",
                backgroundColor: "white",
                paddingBottom: 8,
                paddingTop: 8,
              }}
            >
              {products}
            </MList>
          </StickyContainer>
        </>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  language: state.store.language,
  settings: state.store.store.settings,
  isNotificationDismissed: state.store.isNotificationDismissed,
  filters: state.productFilter,
  cart: state.cart.cart,
  categories: state.store.store.categories,
  usedComponents: state.store.used_components,

  nutritionalFactMaxMin: (state) =>
    state.productFilter?.allProductNutritionFact,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(List);
